import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SidebarLayout from 'components/Layout/Layout';
import { API_URL } from 'env';
import { toast } from "react-toastify";
import { Modal } from "antd";
import { Select } from "antd";

const { Option } = Select;

const EditDailyReading: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [locale, setLocale] = useState<string>('en')
  const [form, setForm] = useState({
    number: 0,
    description: {
      en: '',
      vi: '',
    },
    type: 'Annual',
  });

  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingData(true);
        const response = await fetch(`${API_URL}api/v1/be/coaching-daily-personal/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const json = await response.json();
        console.log(json.data.description)

        let descriptionParse;

        if (typeof json.data.description === 'string') {
          descriptionParse = { en: json.data.description, vi: '' };
        } else {
          const desParsed = JSON.parse(json.data.description);
          descriptionParse = desParsed;
        }

        // try {
        //   const desParsed = JSON.parse(json.data.description);
        //   console.log(desParsed)
        //   if (desParsed && typeof desParsed === "object" && ("en" in desParsed || "vi" in desParsed)) {
        //     descriptionParse = desParsed;
        //   } else {
        //     descriptionParse = { en: json.data.description, vi: '' };
        //   }
        // } catch {
        //   descriptionParse = { en: json.data.description, vi: '' };
        // }

        if (json.status) {
          setForm({
            ...json.data,
            description: descriptionParse,
          });

          console.log(form)
        } else {
          toast.error("Lấy dữ liệu thất bại!", {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
          });
          navigate('/numerology');
        }
      } catch (error: any) {
        toast.error("Lỗi khi tải dữ liệu: " + error.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        navigate('/numerology');
      } finally {
        setLoadingData(false);
      }
    };
    fetchData();
  }, [id, navigate]);

  const handleSave = async () => {
    if (locale === 'en') {
      if (!form.description.en.trim()) {
        toast.error("Vui lòng nhập nội dung", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      try {
        setLoading(true);
        const localeData = localStorage.getItem('userData')

        if (localeData) {
          const token = JSON.parse(localeData).access_token

          const response = await fetch(`${API_URL}api/v1/be/coaching-daily-personal/${id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(form),
          });

          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

          const json = await response.json();

          if (json.status) {
            toast.success("Thêm mới thành công", {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
            navigate('/coach-daily');
          } else {
            toast.error('Có lỗi: ' + (json.message || 'Unknown error'), {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        } else {
          toast.error('Có lỗi: ' + ('Access denied. Permission required'), {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
          });
        }
      } catch (error: any) {
        toast.error('Lỗi khi thêm mới: ' + error.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      } finally {
        setLoading(false);
      }
    } else if (locale === 'vi') {
      if (!form.description.en.trim()) {
        toast.error("Vui lòng nhập nội dung", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      try {
        setLoading(true);
        const localeData = localStorage.getItem('userData')

        if (localeData) {
          const token = JSON.parse(localeData).access_token

          const response = await fetch(`${API_URL}api/v1/be/coaching-daily-personal/${id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(form),
          });

          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

          const json = await response.json();

          if (json.status) {
            toast.success("Thêm mới thành công", {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
            navigate('/coach-daily');
          } else {
            toast.error('Có lỗi: ' + (json.message || 'Unknown error'), {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        } else {
          toast.error('Có lỗi: ' + ('Access denied. Permission required'), {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
          });
        }
      } catch (error: any) {
        toast.error('Lỗi khi thêm mới: ' + error.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      } finally {
        setLoading(false);
      }
    }
  };


  if (loadingData) return <p>Đang tải dữ liệu...</p>;

  return (
    <>
      <SidebarLayout title={<h4 className="text-2xl font-bold !m-0 py-4">Chỉnh sửa Numerology</h4>}>
        <div className="p-4 bg-white rounded shadow">
          <h3 className="text-xl font-bold mb-4" style={{ color: '#5e5873' }}>
            Chỉnh sửa
          </h3>
          <div className="grid grid-cols-2 gap-4">
            <div className="mb-4">
              <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
                Ngôn ngữ
              </label>
              <Select
                value={locale}
                style={{ width: '100%' }}
                onChange={(e) => setLocale(e)}
                placeholder="Select a language"
              >
                <Option value='vi'>
                  Vietnam
                </Option>
                <Option value='en'>
                  English
                </Option>
              </Select>
            </div>

            <div className="mb-4">
              <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
                Number
              </label>
              <input
                type="number"
                min="1"
                max="9"
                value={form.number}
                onChange={(e) =>
                  setForm({
                    ...form,
                    number: Number(e.target.value),
                  })
                }
                className="w-full border p-2 rounded"
                style={{ border: '1px solid #ccc' }}
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="mb-4">
              <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
                Type
              </label>
              <Select
                value={form.type}
                style={{ width: '100%' }}
                onChange={(value) => setForm({
                  ...form,
                  type: value,
                })}
                placeholder="Select a language"
              >
                <Option value='annual'>
                  Annual
                </Option>
                <Option value='monthly'>
                  Monthly
                </Option>
                <Option value='daily'>
                  Daily
                </Option>
              </Select>
            </div>
          </div>
          <div className="mb-4">
            <label className="block font-semibold mb-1" style={{ color: '#5e5873', marginBottom: '10px' }}>
              Nội dung
            </label>
            <div className="border rounded" style={{ border: '1px solid #ccc' }}>
              <textarea value={locale === 'en' ? form.description.en : form.description.vi} onChange={(value) =>
                setForm({
                  ...form,
                  description: {
                    ...form.description,
                    [locale]: value.target.value,
                  },
                })
              } className='w-full p-2' name="" id="" rows={7} />
            </div>
          </div>

          <div className="flex justify-end gap-2">
            <button
              onClick={() => navigate('/coach-daily')}
              className="border px-4 py-2 rounded"
              disabled={loading}
            >
              Hủy
            </button>
            <button
              onClick={handleSave}
              className="bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50"
              disabled={loading}
            >
              {loading ? 'Đang xử lý...' : 'Lưu'}
            </button>
          </div>
        </div>
      </SidebarLayout>
    </>
  );
};

export default EditDailyReading;
